'use client';

import { useAuthMutations  } from '@/modules/authentication/contracts';
import type { LoginDto } from '@/modules/authentication/contracts';

import { Result } from '@packages/domain-driven';

import { useAuthStore } from '../stores/auth.store';

export const useLogin = () => {
	const { setAuth } = useAuthStore();
	const { loginMutation } = useAuthMutations();

	const submit = async (form: LoginDto) => {
		try {
			const response = await loginMutation.mutateAsync(form);
			const { user } = response.body.result;

			setAuth(user);

			return Result.ok();
		}
		catch {
			return Result.fail('Login failed');
		}
	};

	return {
		submit,
		...loginMutation,
	};
};
